<div class="web-view" fxHide.xs fxHide.sm fxHide.lt-md fxFlex.md>

    <div class="navbar-div">
        <app-web-navbar></app-web-navbar>
    </div>


    <div class="main-div" fxLayout="row wrap">

        <div fxLayout="row">
            <div fxLayout="column wrap" class="description-div">
                <p class="event-heading">
                    {{aboutpage?.heading}}
                </p>
                <p>
                    {{aboutpage?.mainDescription}}
                </p>
            </div>

            <div class="image-div" fxLayout="column wrap">

                <img class="image" src="{{aboutpage?.mainImage}}" alt="Cinejoy Home Page">

            </div>
        </div>

        <div fxLayout="row wrap" class="button-main-div" *ngIf="!userLoggedIn">
            <div fxLayout="row wrap" class="button-div" fxLayoutAlign="start center"
                *ngFor="let btn of aboutpage?.topButtons">

                <a href="{{btn.buttonUrl}}"><button class="btn"><span
                            class="btn_effect">{{btn.buttonName}}</span></button></a>

            </div>
        </div>


    </div>


    <div class="spotlight-div event-div" fxLayout="row">

        <div class="event-image-div" fxLayout="row">
            <video class="event-image" src="{{aboutpage?.videoUrl}}" controls="true" disablePictureInPicture
            controlsList="nodownload noplaybackrate"poster="/assets/images/maxresdefault.jpg" allowfullscreen></video>
        </div>

        <div class="event-details-div" fxLayout="row wrap" fxLayoutAlign="start center">
            <p class="event-details">{{aboutpage?.creaticsDescription}}</p>
            <div fxLayout="column wrap" class="button-div-new" fxLayoutGap="30px">

                <div *ngFor="let btn of aboutpage?.bottomButtons">

                    <a href="{{btn.buttonUrl}}"><button class="mobileBtn">{{btn.buttonName}}</button></a>

                </div>

            </div>
        </div>

    </div>
    <div class="footer-div">
        <app-cinejoy-footer></app-cinejoy-footer>
    </div>


</div>
<!-- wev view ended -->

<!-- mobile view started -->

<div class="mobile-view" fxHide.lg fxHide.md fxHide.lt fxFlex.lt-md fxShow.xs fxHide.gt-lg>

    <div class="mobile-navbar">
        <app-sidebar></app-sidebar>
    </div>

    <div class="navbar-div">
        <app-web-navbar></app-web-navbar>
    </div>

    <div class="main-div-mob" fxLayout="column wrap">

        <div fxLayout="column">

            <div class="image-div-mob" fxLayout="column" fxLayoutAlign="start center">

                <img class="image-mob" src="{{aboutpage?.mainImage}}" alt="Cinejoy About Page">

            </div>

            <div fxLayout="column" class="description-div-mob">

                <p class="event-heading-mob">
                    {{aboutpage?.heading}}
                </p>

                <p class="description">
                    {{aboutpage?.mainDescription}}
                </p>
            </div>

            <div fxLayout="column wrap" class="button-div-mob" fxLayoutGap="10px" *ngIf="!userLoggedIn">

                <div *ngFor="let btn of aboutpage?.topButtons">
                    <a href="{{btn.buttonUrl}}"><button class="mobileBtnjoin">{{btn.buttonName}}</button></a>
                </div>

            </div>

        </div>

    </div>

    <div class="spotlight-div-mob event-div-mob" fxLayout="column wrap">

        <div class="event-image-div-mob" fxLayout="column">
            <video class="event-image-mob" src="{{aboutpage?.videoUrl}}" controls="true" disablePictureInPicture
                controlsList="nodownload noplaybackrate"poster="/assets/images/maxresdefault.jpg" allowfullscreen>
            </video>
        </div>

        <div class="event-details-div-mob" fxLayout="column wrap" fxLayoutAlign="start">
            <p class="event-details-mob">
                {{aboutpage?.creaticsDescription}}
            </p>

            <div fxLayout="column wrap" class="mob-button-div-new" fxLayoutGap="10px">


                <div *ngFor="let btn of aboutpage?.bottomButtons">

                    <a href="{{btn.buttonUrl}}"><button class="mobileBtn">{{btn.buttonName}}</button></a>

                </div>

            </div>
        </div>

    </div>


    <div class="footer-div">
        <app-cinejoy-mobile-footer></app-cinejoy-mobile-footer>
    </div>

</div>